module.exports = "<div class=\"ai-timeseries\">\r\n  <canvas #chartCanvas></canvas>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/work/internal-frontend/src/app/content-page/common/skill-learning/components/admin/ai-statistics-timeseries/ai-statistics-timeseries.component.html
// module id = ../../../../../src/app/content-page/common/skill-learning/components/admin/ai-statistics-timeseries/ai-statistics-timeseries.component.html
// module chunks = main